import { render, staticRenderFns } from "./ApplicantCreateForm.vue?vue&type=template&id=22ae3c5a&scoped=true"
import script from "./ApplicantCreateForm.vue?vue&type=script&lang=js"
export * from "./ApplicantCreateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ae3c5a",
  null
  
)

export default component.exports